import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import SearchSource from '~/constants/srp/SearchSource';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import SearchContext from '~/context/srp/SearchContext';
import { useSearchSource } from '~/context/srp/SearchEventsDataContext';

const useGetIsFromSearchBar = () => {
  const searchSource = useSearchSource();

  switch (searchSource) {
    case SearchSource.DefaultSuggestion:
    case SearchSource.RecentSearch:
    case SearchSource.SavedSearch:
    case SearchSource.TextSearch:
      return true;
    default:
      return false;
  }
};

export default function useRegenerateSearchSessionId() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { regenerateSearchSessionId } = useContext(SearchContext);
  const isFromSearchBar = useGetIsFromSearchBar();

  // If applied filters changed and now none exist, or filters come from search bar, start a new search session
  useSubsequentEffect(() => {
    if (Object.keys(appliedFilters).length === 0 || isFromSearchBar) {
      regenerateSearchSessionId();
    }
  }, [appliedFilters, isFromSearchBar, regenerateSearchSessionId]);
}
